import { Box, Button, DialogActions, Modal, Stack, TextField, Typography } from '@mui/material'
import type React from 'react'
import { useContext, useEffect, useRef, useState } from 'react'
import { inputSchema } from '../schema/inputSchema'
import { LanguageContext } from '../util/LanguageContext'

type ConversionModalAddDialogProps = {
  open: boolean
  title: string
  onClose: () => void
  onSave: (preText: string, postText: string) => void
}

export const ConversionModalAddDialog: React.FC<ConversionModalAddDialogProps> = props => {
  const { open, title, onClose, onSave } = props
  const [isOpen, setIsOpen] = useState(open)
  const [inputPreText, setInputPreText] = useState('')
  const [inputPostText, setInputPostText] = useState('')
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const inputPreRef = useRef<HTMLInputElement | null>(null)
  const inputPostRef = useRef<HTMLInputElement | null>(null)
  const [errorPreMessage, setErrorPreMessage] = useState('')
  const [errorPostMessage, setErrorPostMessage] = useState('')
  const [preFlag, setPreFlag] = useState(false)
  const [postFlag, setPostFlag] = useState(false)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const preValidate = async (value: string) => {
    try {
      await inputSchema.validate(value)
      setErrorPreMessage('')
      if (postFlag === true) {
        console.log('pre ok')
        setIsButtonDisabled(false)
      }
    } catch (err: any) {
      setErrorPreMessage(err.message)
      setIsButtonDisabled(true)
    }
  }

  const postValidate = async (value: string) => {
    try {
      await inputSchema.validate(value)
      setErrorPostMessage('')
      if (preFlag === true) {
        console.log('post ok')
        setIsButtonDisabled(false)
      }
    } catch (err: any) {
      setErrorPostMessage(err.message)
      setIsButtonDisabled(true)
    }
  }

  const handlePreTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsButtonDisabled(true)
    if (event.target.value === '') {
      setPreFlag(false)
    } else {
      setPreFlag(true)
    }
    setInputPreText(event.target.value)
    preValidate(event.target.value)
  }

  const handlePostTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsButtonDisabled(true)
    if (event.target.value === '') {
      setPostFlag(false)
    } else {
      setPostFlag(true)
    }
    setInputPostText(event.target.value)
    postValidate(event.target.value)
  }

  const handleSave = () => {
    onSave(inputPreText, inputPostText)
    onClose()
    setIsOpen(false)
  }
  const handleClose = (event: React.MouseEvent<HTMLInputElement>, reason: 'backdropClick') => {
    if (reason === 'backdropClick') return
    onClose()
    setIsOpen(false)
  }
  useEffect(() => {
    if (inputPreText === '') {
      setIsButtonDisabled(true)
    }
    if (inputPreText === '') {
      setIsButtonDisabled(true)
    }
  }, [inputPreText])

  useEffect(() => {
    if (inputPostText === '') {
      setIsButtonDisabled(true)
    }
    if (inputPostText === '') {
      setIsButtonDisabled(true)
    }
  }, [inputPostText])

  useEffect(() => {
    if (inputPreRef.current) {
      inputPreRef.current.focus()
    }
  }, [])

  useEffect(() => {
    if (inputPostRef.current) {
      inputPostRef.current.focus()
    }
  }, [])

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '332px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '598px',
          width: '640px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: '0px 2px 2px #00000014',
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Typography
            sx={{
              mt: '48px',
              font: 'normal normal bold 32px/48px BIZ UDGothic',
              textAlign: 'left',
            }}
          >
            {translation['button_create_new']}
          </Typography>
          <Typography
            sx={{
              mt: '18px',
              mb: '18px',
              mr: '50px',
              ml: '50px',
              color: '#282828',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              textAlign: 'center',
            }}
          >
            {`${translation['label_input_xxxxx_word']}`.replace('{title}', title || '')}
          </Typography>
          <p style={{ top: '10px', width: '480px' }}>{translation['label_force_word_before']}</p>
          <TextField
            label=""
            value={inputPreText}
            error={!!errorPreMessage}
            helperText={errorPreMessage ? translation[errorPreMessage] : ' '}
            inputRef={inputPreRef}
            onChange={handlePreTextChange}
            InputProps={{
              sx: {
                font: 'normal normal normal 21px/34px BIZ UDPGothic',
                borderRadius: '10px',
                height: '72px',
                width: '480px',
                pl: '8px',
                background: '#F4F4F4',
              },
            }}
            sx={{
              mt: '5px',
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: errorPreMessage ? 'red' : '#282828',
                },
              },
            }}
            // focused
          />
          <p style={{ width: '480px' }}>{translation['label_force_word_after']}</p>
          <TextField
            label=""
            value={inputPostText}
            error={!!errorPostMessage}
            helperText={errorPostMessage ? translation[errorPostMessage] : ' '}
            inputRef={inputPostRef}
            onChange={handlePostTextChange}
            InputProps={{
              sx: {
                font: 'normal normal normal 21px/34px BIZ UDPGothic',
                borderRadius: '10px',
                height: '72px',
                width: '480px',
                pl: '8px',
                background: '#F4F4F4',
              },
            }}
            sx={{
              mt: '5px',
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: errorPostMessage ? 'red' : '#282828',
                },
              },
            }}
          />
          <DialogActions sx={{ mt: '30px' }}>
            <Button
              onClick={onClose}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#282828',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '2px solid #282828',
                borderRadius: '10px',
                mt: '5px',
                mr: '30px',
                '&:hover': {
                  background: '#FFFFFF',
                  opacity: 0.8,
                },
              }}
            >
              {translation['button_cancel']}
            </Button>
            <Button
              type="submit"
              disabled={isButtonDisabled}
              onClick={handleSave}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: isButtonDisabled ? '#CACACA' : '#FFFFFF',
                background: isButtonDisabled ? '#F4F4F4 0% 0% no-repeat padding-box' : '#282828',
                borderRadius: '10px',
                mt: '5px',
                '&:hover': {
                  backgroundColor: '#282828',
                  opacity: 0.8,
                  boxShadow: 0,
                },
              }}
            >
              {translation['button_create']}
            </Button>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}
